import React, { useState } from "react";
import { useDispatch } from "react-redux";

import AddIcon from '@mui/icons-material/Add';
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import PortraitIcon from '@mui/icons-material/Portrait';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import DeletePopup from "../helpers/DeletePopup";
import SegmentCreateForm from "./SegmentCreateForm";
import ModalElement from "../Modal";
import { addCustomerSegment, deleteCustomerSegment, editCustomerSegment } from "../../actions/presentationAction";

const CustomerSegments = ({ valueModels, presentation }) => {
    // const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [segmentCreateOpen, setSegmentCreateOpen] = useState(false)
    const [editSegmentId, setEditSegmentId] = useState(null);
    const [deleteSegmentPopupOpen, setDeleteSegmentPopupOpen] = useState(false);
    const [deleteSegmentId, setDeleteSegmentId] = useState(null);

    const handleClose = () => {
        setSegmentCreateOpen(false)
        setEditSegmentId(null)
    }

    const toggleSegmentCreateOpen = () => {
        setSegmentCreateOpen(!segmentCreateOpen)
    }

    const toggleSegmentDeleteOpen = () => {
        setDeleteSegmentPopupOpen(!deleteSegmentPopupOpen)
    }

    const handleSegmentSubmit = (values) => {
        // Remove commas from all variable values
        const cleanedVariables = Object.fromEntries(
            Object.entries(values.variables || {}).map(([key, variable]) => [
                key,
                {
                    ...variable,
                    value: typeof variable.value === 'string'
                        ? variable.value.replace(/,/g, '')
                        : variable.value
                }
            ])
        );

        const cleanedValues = {
            ...values,
            variables: cleanedVariables
        };

        if (!editSegmentId) {
            dispatch(addCustomerSegment(presentation.id, cleanedValues));
        } else {
            dispatch(editCustomerSegment(presentation.id, editSegmentId, cleanedValues));
        }

        handleClose();
    };

    const editSegment = (id) => {
        setEditSegmentId(id)
        toggleSegmentCreateOpen()
    }

    const deleteSegment = (id) => {
        setDeleteSegmentId(id)
        toggleSegmentDeleteOpen()
    }

    function renderCreateSegmentModal() {
        return (
            <ModalElement
                modalOpen={segmentCreateOpen}
                modalWidth={300}
                handleClose={handleClose}
                header={`${editSegmentId ? 'Edit' : 'Create'} Customer segment`}
                // instruction="Please be as detailed as possible"
                content={
                    <SegmentCreateForm
                        valueModels={valueModels}
                        editSegmentId={editSegmentId}
                        editSegment={presentation?.customer_segments?.find(segment => segment.id === editSegmentId)}
                        onSubmit={handleSegmentSubmit}
                    />
                }
            />
        )
    }

    const SegmentList = ({ segments, onEdit, onDelete }) => {
        return (
            <Stack spacing={2}>
                {segments?.map((segment, index) => (
                    <Paper
                        key={index}
                        sx={{
                            display: 'flex',
                            height: 18,
                            maxWidth: 400,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderRadius: '16px',
                            backgroundColor: 'primary.main',
                            p: 2,
                        }}
                    >
                        <Typography
                            variant="body2"
                            display="flex"
                            alignItems="center"
                            sx={{ color: 'white' }}
                        >
                            <PortraitIcon fontSize="inherit" />
                            <span style={{ marginLeft: 4 }}>{segment.name}</span>
                        </Typography>
                        <Box>
                            <IconButton onClick={() => onEdit(segment.id)} sx={{ color: 'white' }} size="small">
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton onClick={() => onDelete(segment.id)} sx={{ color: 'white' }} size="small">
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Paper>
                ))}
            </Stack>
        );
    };

    return (
        <Box>
            <SegmentList
                segments={presentation.customer_segments}
                onEdit={editSegment}
                onDelete={deleteSegment}
            />
            <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={toggleSegmentCreateOpen}
                sx={{ textTransform: 'none', borderRadius: '20px', mt: 3 }} // prevents the text from being capitalized
            >
                Add
            </Button>
            {renderCreateSegmentModal()}
            <DeletePopup open={deleteSegmentPopupOpen} onClose={toggleSegmentDeleteOpen} onDelete={() => dispatch(deleteCustomerSegment(presentation.id, deleteSegmentId))} />
        </Box>
    )
}

export default CustomerSegments